import { SxProps, Theme, useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { FC, memo } from 'react';

import { COLOR } from '../../theme/type';
import { colorToCss } from '../../theme/utils';
import { FooterGroup } from '../../types/footer';
import { H4 } from '../heading/Hx';
import List from '../list/List';
import ListItem from '../list/ListItem';
import Route from '../route/Route';
import { FiberIcon, SubHeader } from './styled';

const SX_H4: SxProps<Theme> = {
  fontSize: '18px !important',
  fontWeight: 'bold',
};

const SX_ROUTE: SxProps<Theme> = {
  '&:hover': { color: colorToCss(COLOR.Gray3) },
  color: colorToCss(COLOR.Gray1),
};

type LinkBlockProps = { group: FooterGroup };

const LinkGroup: FC<LinkBlockProps> = ({ group: { links, text } }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <>
      <H4 color={COLOR.Gray1} sx={SX_H4} uppercase={false}>
        {text}
      </H4>

      <List itemProps={{ margin: { y: '0.5rem' } }}>
        {links.map(({ href, icon, text }, index) => (
          <ListItem key={index}>
            {href ? (
              <>
                {icon || (isMobile && <FiberIcon />)}
                <Route href={href} sx={SX_ROUTE} variant='body2'>
                  {text}
                </Route>
              </>
            ) : (
              <SubHeader component='span' variant='body2'>
                {text}
              </SubHeader>
            )}
          </ListItem>
        ))}
      </List>
    </>
  );
};

export default memo(LinkGroup);
